import axios from 'axios';
import { req } from './axiosFun';

/**
 * 景点管理
 **/
// 获取景点列表
export const campList = (params) => { return axios.get("/customer/listEach") };
export const campListSave  = (params) => { return req("post", "/customer/addEach", params) };
export const campListDel  = (params) => { return req("post", "/customer/deleteEach", params) };






// WEBPACK FOOTER //
// ./src/api/campsMG8.js